import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import DocumentTitle from 'react-document-title'

import styles from './Style.css'
import TextInput from '../../forms/TextInput'

import {connect} from 'react-redux'
import {Field, reduxForm, formPropTypes} from 'redux-form'
import {link as clientWebLink} from '../../../lib/clientweb'
import validate from 'mb-app-common/lib/form/validators'

import {login, syncTokenWithLegacy, setCaptcha, INVALID_USERNAME_OR_PASSWORD, LOGIN_MUST_RESET_PASS_ERROR_CODE} from 'mb-app-common/store/actions/auth'

import ReCAPTCHA from 'react-google-recaptcha'

export class Login extends PureComponent{
	static propTypes = {
		referrer: PropTypes.string,
		errorCode: PropTypes.string,
		...formPropTypes
	}

	static defaultProps = {
		referrer: '/home'
	}

	static contextTypes = {
		router: PropTypes.object
	}

	static validate(data){
		return validate.fixForReduxForm(validate(data, {
			username: {
				username: {}
			},
			password: {
				presence: {
					message:'^A password is required'
				}
			}
		}))
	}

	submit(data, dispatch){
		return dispatch(login(data.username, data.password, false))
			.then((login) => dispatch(syncTokenWithLegacy(login.token.accessToken)))
			.then(() => {
				this.context.router.history.push(this.props.referrer)
			})
	}

	render(){
		const {submitting} = this.props
		let errorMessage

		switch(this.props.errorCode){
			case undefined:
				break
			case INVALID_USERNAME_OR_PASSWORD:
				errorMessage = 'Incorrect username or password. Please try again or contact Customer Support.'
				break

			case LOGIN_MUST_RESET_PASS_ERROR_CODE:
				errorMessage = "Your account is locked due to failed login attempts.\nPlease complete the captcha to continue."
				break

			default:
				errorMessage = 'Unable to communicate with the MyBudget service. Please try again in a few moments'
		}

		return (
			<DocumentTitle title="MyBudget - Login">
				<div className={styles.component}>
					<If condition={errorMessage}>
						<div className="alert alert-danger" role="alert">
							{errorMessage}
						</div>
					</If>
					<div className="panel panel-primary">
						<header className="panel-heading">
							<h1 className="panel-title">Login</h1>
						</header>
						<section className="panel-body">
							<form onSubmit={this.props.handleSubmit(this.submit.bind(this))}>
								<div className="clearfix">
									<Field
										component={TextInput.renderForForm}
										name='username'
										label='Client Number or email:'
										icon="user"
										tabIndex="1"
										type="text"
										disabled={submitting}
									/>

									<Field
										component={TextInput.renderForForm}
										name='password'
										label='Password:'
										icon="lock"
										tabIndex="2"
										type="password"
										disabled={submitting}
									/>

									<a tabIndex="-1" href={clientWebLink('/login/ForgotPassword')} className="pull-right forgot-password">Forgot password?</a>
								</div>


								<If condition={this.props.errorCode == LOGIN_MUST_RESET_PASS_ERROR_CODE}>
									<ReCAPTCHA
										sitekey='6LefLQwUAAAAALqPXFoGcMOdfMTAxqghyA8A-1Sf'
										onChange={(e) => this.props.dispatch(setCaptcha(e))}
										onExpired={() => this.props.dispatch(setCaptcha(undefined))}
										tabIndex="3"
										ref={(captcha) => this.captcha = captcha}
										className={styles.recaptcha}
									/>
								</If>

								<button
									tabIndex="-1"
									id={styles.submitButton}
									type="submit"
									className="btn btn-primary"
								>{submitting ? <span className="glyphicon glyphicon-cog spinner"></span>: 'Sign In'}</button>

							</form>
						</section>
						<footer className="panel-footer">
							<span>
								<a tabIndex="-1" href={clientWebLink('/signup')}>Activate web password</a>
							</span>

							<div className="pull-right">
								<Link to='/login/staff' >Staff Login</Link>
							</div>
						</footer>
					</div>
				</div>
			</DocumentTitle>
		)
	}
}

export default connect((state) => ({errorCode: state.Auth.loginErrorMessage}))(
	reduxForm({
		form: 'login',
		destroyOnUnmount: true,
		validate: Login.validate
	})(Login)
)



// WEBPACK FOOTER //
// ./client/components/Login/Client/index.js